import { useChartModelCustomDateRangeValues } from 'finviz-charts/app/controllers/chart-controls/use-chart-model-custom-date-range-values'
import { useChartLayoutGlobalModelAsync, useModelState } from 'finviz-charts/app/lib-export'

export function useChartTimeframePathWatch() {
  const isPremium = window.FinvizSettings.hasUserPremium
  const { chartLayoutModel } = useChartLayoutGlobalModelAsync()
  const chartModel = useModelState(chartLayoutModel?.activeChart ?? null, {
    watchProperties: ['timeframe'],
  })
  const { generateChartLayoutRouterPath } = useChartModelCustomDateRangeValues({
    chartModel,
    isPremium,
  })

  if (!chartModel) return null

  const { pathname, search } = generateChartLayoutRouterPath({
    ticker: chartModel?.ticker,
    timeframe: chartModel?.timeframe,
    dateRange: chartModel?.dateRange,
  })

  return `${pathname}${search}`
}
